import { Box, Button, Typography } from '@mui/material';
import Image from 'next/image';
import { AccessibleHiddenText } from '../../../AccessibleHiddenText';
import type { HouseAdProps } from './types';

export const HorizontalHouseAd = ({
  headline,
  body,
  ctaHref,
  ctaNode,
  ctaText,
  featuredMedia,
}: HouseAdProps): React.ReactNode => {
  return (
    <Box
      sx={{
        border: '1px solid',
        borderColor: 'neutral.lighter',
        borderRadius: '2px',
        paddingX: 4,
        display: 'flex',
        flexDirection: { xs: 'column-reverse', md: 'row' },
        columnGap: 4,
        rowGap: 2,
        justifyContent: 'space-between',
        alignItems: { xs: 'center', md: 'flex-end' },
      }}
    >
      <Box
        sx={{
          marginTop: { xs: 0, md: 4 },
          marginBottom: 4,
          display: 'flex',
          flexDirection: 'column',
          alignItems: { xs: 'center', md: 'flex-start' },
        }}
      >
        <Typography
          variant="textBold"
          sx={{
            marginBottom: 1,
            textAlign: { xs: 'center', md: 'initial' },
          }}
        >
          {headline}
        </Typography>
        <Typography
          variant="text"
          sx={{
            marginBottom: 2,
            textAlign: { xs: 'center', md: 'initial' },
          }}
        >
          {body}
        </Typography>
        {ctaHref ? (
          <Button component="a" variant="contained" href={ctaHref} fullWidth={false}>
            {ctaText}
            <AccessibleHiddenText component="span">on NerdWallet's site</AccessibleHiddenText>
          </Button>
        ) : (
          <>{ctaNode}</>
        )}
      </Box>
      <Box sx={{ marginTop: 0.5, display: 'flex' }}>
        {featuredMedia?.sourceUrl && (
          <Image
            alt={featuredMedia.altText || headline}
            width={Math.min(250, (featuredMedia.width / featuredMedia.height) * 200)}
            height={featuredMedia.height}
            src={featuredMedia.sourceUrl}
            style={{ height: 'auto' }}
          />
        )}
      </Box>
    </Box>
  );
};
